import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AutoComplete, Input, Drawer } from "antd";
import "./LocationFilter.css";
import FilterState from "./state.Filter";
import FilterIndustry from "./industry.filter";
import FilterCompany from "./company.Filter";
import CompanyFilter from "./filter.Company";
const Companies = ({
  setCheck,
  check,
  emptyCountryInput,
  setEmptyCountryInput,
  searchLocationFilter,
  setCheckLocationCountry,
  checkLocationCountry,
  setCheckCountryId,
  checkCountryId,
  countryObj,
  setcountryObj,
  setPrevIndustryObj,
  setEmptyPrevIndustryInput,
  emptyPrevIndustryInput,
  fromCandMkt,
  setEmptyCompanyInput,emptyCompanyInput,setFilterCompany,addQueryCompany
}) => {
  // const [locationValue, setLocationValue] = useState([]);
  const [visible, setVisible] = useState(false);

  // const filters = useSelector(state => state.searchSkillListingReducer.filters);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const handleCountryChange = (flag) => {
    // console.log("called log**");
    if (flag) {
      if ( emptyCompanyInput=== "") {
        setEmptyCompanyInput();
      }
    }
    if (!flag) {
      setEmptyCompanyInput("");
    }
    setVisible(flag);
  };

  const containerStyle = {
    position: "relative",
    height: "100vh !important",
    overflow: "hidden",
    // textAlign: 'center',
  };

  const valueCheck = check?? '';

  return (
    <div className="search-location-filter-mobile">
      <Drawer
        className="location-drawer"
        onClose={onClose}
        visible={visible}
        closable={true}
        placement={"top"}
        afterOpenChange={(e) => {
          handleCountryChange(e);
        }}
        contentWrapperStyle={containerStyle}
        title={"Select company"}
      >
        <CompanyFilter
            searchLocationFilter={searchLocationFilter}
            setCheck={setCheck}
            check={check}
            setEmptyCompanyInput={setEmptyCompanyInput}
            emptyCompanyInput={emptyCompanyInput}
            setFilter={setFilterCompany}
            addQuery = {addQueryCompany}
            mobileFilter={true}
            fromCandMkt={fromCandMkt ?? false}
            setVisible={setVisible}
        />
      </Drawer>

      <Input
        className="input"
        value={valueCheck}
        onClick={showDrawer}
        type={"input"}
        placeholder="Search company"
      />
    </div>
  );
};
export default Companies;
